import React, { Component } from 'react';
import logo from "../../../assets/img/MAXMRJ-Logo-1.png"
import { apiPath } from 'api';
import { generalAuthTokenHeader } from '__helpers/auth-header';
import { userService } from '_services/user.service';

class PreviewSubmittedSurvey extends Component {
  constructor(props) {
    super(props);
    let spinner = document.getElementById("loadingSpinner");
    this.state = {
      spinner: spinner,
      showSurvey: true,
      loading: false,
      submitted: true,
      error: null,
      surveyData: {
        "formResponseId": null,
        "submittedAt": null,
        "surveyForm": {
          "surveyFormId": 811953,
          "title": "Default Health survey",
          "description": "Health related survey",
          "introText": "Title.",
          "endText": "Thank you.",
          "dpId": 812352,
          "isDefault": true,
          "questions": [
            {
              "questionId": 812651,
              "questionText": "In the past 7 days, how often did you miss or delay a prescribed dose?",
              "required": true,
              "questionOrder": 1,
              "weightage": 3,
              "inputTypeId": 766101,
              "inputTypeName": "Short Answer",
              "domainId": 768650,
              "isDefault": true,
              "options": null,
              "answer": {
                "answerId": null,
                "questionId": null,
                "answerText": null,
                "hasOption": null,
                "answerOption": []
              }
            },
            {
              "questionId": 812652,
              "questionText": "Today, how confident are you that you can bathe, dress, and move around without help?",
              "required": true,
              "questionOrder": 2,
              "weightage": 2,
              "inputTypeId": 766101,
              "inputTypeName": "Short Answer",
              "domainId": 768700,
              "isDefault": true,
              "options": null,
              "answer": {
                "answerId": null,
                "questionId": null,
                "answerText": null,
                "hasOption": null,
                "answerOption": []
              }
            },
            {
              "questionId": 812653,
              "questionText": "How often have you felt confused or disoriented in the last week?",
              "required": false,
              "questionOrder": 3,
              "weightage": 4,
              "inputTypeId": 766101,
              "inputTypeName": "Short Answer",
              "domainId": 768750,
              "isDefault": true,
              "options": null,
              "answer": {
                "answerId": null,
                "questionId": null,
                "answerText": null,
                "hasOption": null,
                "answerOption": []
              }
            },
            {
              "questionId": 812654,
              "questionText": "Right now, how comfortable and free of pain do you feel?",
              "required": false,
              "questionOrder": 4,
              "weightage": 2,
              "inputTypeId": 766101,
              "inputTypeName": "Short Answer",
              "domainId": 768800,
              "isDefault": true,
              "options": null,
              "answer": {
                "answerId": null,
                "questionId": null,
                "answerText": null,
                "hasOption": null,
                "answerOption": []
              }
            },
            {
              "questionId": 812655,
              "questionText": "Do you have someone who can stay with you or check on you daily?",
              "required": true,
              "questionOrder": 5,
              "weightage": 1,
              "inputTypeId": 766103,
              "inputTypeName": "Multiple Choice",
              "domainId": 768850,
              "isDefault": true,
              "options": [
                {
                  "optionId": 812701,
                  "optionText": "Yes"
                },
                {
                  "optionId": 812702,
                  "optionText": "No"
                }
              ],
              "answer": {
                "answerId": null,
                "questionId": null,
                "answerText": null,
                "hasOption": null,
                "answerOption": []
              }
            }
          ]
        },
        "patientContactId": 815756,
        "taskId": 813432,
        "surveyStatus": "DELIVERED"
      }
    };
  }
  componentDidMount() {
    console.log("this.props.taskId", this.props.taskId);
    this.fetchSubmittedSurvey()

  }
  async fetchSubmittedSurvey() {
    this.state.spinner.removeAttribute("hidden", "true");

    let showNotification = {};
    const apiUrl = ` ${apiPath.GetAllSubmittedSurvey}?taskId=${this.props.taskId}`; // <-- your API endpoint

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (response.status === 400) {
        showNotification = { title: "Submitted Survey", message: "Bad Request", type: "danger" };
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else if (!response.ok) {
        showNotification = { title: "Submitted Survey", message: "Error fetching data", type: "danger" };
      }

      const data = await response.json();
      console.log("SubmittedSurvey Fetched: ", data);
      console.log("SubmittedSurvey: ", response.data);

      this.setState({ surveyData: data }); // <-- update surveys from API

      if (showNotification.title) userService.showNotification(showNotification);
    } catch (error) {
      console.error("Error fetching input types", error);
      showNotification = { title: "Input Types", message: "Server Error", type: "danger" };
      userService.showNotification(showNotification);
    }

    this.state.spinner.setAttribute("hidden", "true");
  }

formatBackendDate = (isoString) => {
  if (!isoString) return "-";

  const parts = isoString.split("T");
  const datePart = parts[0];
  const timePartWithMs = parts[1] || "";
  const timePart = timePartWithMs.split(".")[0];

  const timeParts = timePart.split(":");
  let hour = parseInt(timeParts[0], 10);
  const minute = parseInt(timeParts[1], 10);
  const second = parseInt(timeParts[2], 10);

  const ampm = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12;

  const pad = (num) => (num < 10 ? "0" + num : num.toString());

  return `${datePart} ${pad(hour)}:${pad(minute)}:${pad(second)} ${ampm}`;
};

 pacificFormatBackendDate = (dateStr, format = "MM/dd/yyyy hh:mm:ss a") => {
  if (!dateStr) return "";

  let dateObj;

  // Convert input into Date object
  if (dateStr instanceof Date) {
    dateObj = dateStr;
  } else {
    dateObj = new Date(dateStr);
    if (isNaN(dateObj)) return "";
  }

  // Convert to Pacific Time using Intl.DateTimeFormat
  const pacificFormatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  // Extract all parts
  const parts = pacificFormatter.formatToParts(dateObj);
  const getPart = (type) => parts.find((p) => p.type === type)?.value || "";

  const month = getPart("month");
  const day = getPart("day");
  const year = getPart("year");
  const hour = getPart("hour");
  const minute = getPart("minute");
  const second = getPart("second");
  const ampm = getPart("dayPeriod");

  // Format output based on requested format
  if (format === "yyyy-MM-dd hh:mm:ss a") return `${year}-${month}-${day} ${hour}:${minute}:${second} ${ampm}`;
  if (format === "MM/dd/yyyy hh:mm:ss a") return `${month}/${day}/${year} ${hour}:${minute}:${second} ${ampm}`;
  if (format === "dd/MM/yyyy hh:mm:ss a") return `${day}/${month}/${year} ${hour}:${minute}:${second} ${ampm}`;

  
  console.log("pacific date time",`${month}/${day}/${year} ${hour}:${minute}:${second} ${ampm}`);
  // Default fallback
  return `${month}/${day}/${year} ${hour}:${minute}:${second} ${ampm}`;

};





  renderQuestion = (q, index) => {
    const baseLabel = (
      <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
        {index + 1}. {q.questionText}
        {q.required && <span style={{ color: 'red' }}> *</span>}
        {q.weightage && <span style={{ fontSize: '0.9rem', color: '#888', marginLeft: '8px' }}>(Weightage: {q.weightage})</span>}
      </label>
    );

    // Get the submitted answer(s) for this question
    const answerOptions = q.answer?.answerOption || [];
    const answerText = q.answer?.answerText;

    if (q.inputTypeName === 'Exclusive Choice') {
      return (
        <div key={q.questionId} style={{
          marginBottom: '1.5rem',
          padding: '1rem',
          border: '1px solid #e0e0e0',
          borderRadius: '6px'
        }}>
          {baseLabel}

          <div style={{ marginLeft: '16px' }}>
            {q.options.map(opt => (
              <div key={opt.optionId} style={{ margin: '6px 0', display: 'flex', alignItems: 'center' }}>
                <div style={{
                  width: '18px',
                  height: '18px',
                  borderRadius: '50%',
                  border: '2px solid #666',
                  marginRight: '8px',
                  position: 'relative',
                  backgroundColor: answerOptions.some(a => a.optionId === opt.optionId) ? '#1890ff' : 'transparent'
                }}>
                  {answerOptions.some(a => a.optionId === opt.optionId) && (
                    <div style={{
                      position: 'absolute',
                      top: '3px',
                      left: '3px',
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      backgroundColor: 'white'
                    }}></div>
                  )}
                </div>
                <span style={{
                  color: answerOptions.some(a => a.optionId === opt.optionId) ? '#1890ff' : 'inherit',
                  fontWeight: answerOptions.some(a => a.optionId === opt.optionId) ? '500' : 'normal'
                }}>
                  {opt.optionText}
                </span>
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (q.inputTypeName === 'Multiple Choice') {
      return (
        <div key={q.questionId} style={{
          marginBottom: '1.5rem',
          padding: '1rem',
          border: '1px solid #e0e0e0',
          borderRadius: '6px'
        }}>
          {baseLabel}

          <div style={{ marginLeft: '16px' }}>
            {q.options.map(opt => (
              <div key={opt.optionId} style={{ margin: '6px 0', display: 'flex', alignItems: 'center' }}>
                <div style={{
                  width: '18px',
                  height: '18px',
                  border: '2px solid #666',
                  marginRight: '8px',
                  position: 'relative',
                  backgroundColor: answerOptions.some(a => a.optionId === opt.optionId) ? '#1890ff' : 'transparent'
                }}>
                  {answerOptions.some(a => a.optionId === opt.optionId) && (
                    <div style={{
                      position: 'absolute',
                      top: '1px',
                      left: '4px',
                      width: '6px',
                      height: '10px',
                      border: 'solid white',
                      borderWidth: '0 2px 2px 0',
                      transform: 'rotate(45deg)'
                    }}></div>
                  )}
                </div>
                <span style={{
                  color: answerOptions.some(a => a.optionId === opt.optionId) ? '#1890ff' : 'inherit',
                  fontWeight: answerOptions.some(a => a.optionId === opt.optionId) ? '500' : 'normal'
                }}>
                  {opt.optionText}
                </span>
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (q.inputTypeName === 'Rating') {
      return (
        <div key={q.questionId} style={{
          marginBottom: '1.5rem',
          padding: '1rem',
          border: '1px solid #e0e0e0',
          borderRadius: '6px'
        }}>
          {baseLabel}

          <div style={{ marginLeft: '16px', marginTop: '8px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '0.9rem', color: '#666' }}>Poor</span>
              {q.options.map(opt => (
                <div key={opt.optionId} style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  border: '2px solid',
                  borderColor: answerOptions.some(a => a.optionId === opt.optionId) ? '#1890ff' : '#ddd',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: answerOptions.some(a => a.optionId === opt.optionId) ? '#1890ff' : 'transparent',
                  color: answerOptions.some(a => a.optionId === opt.optionId) ? 'white' : '#666',
                  fontWeight: '500'
                }}>
                  {opt.optionText}
                </div>
              ))}
              <span style={{ fontSize: '0.9rem', color: '#666' }}>Excellent</span>
            </div>

            {answerOptions.length > 0 && (
              <div style={{ marginTop: '8px', color: '#1890ff', fontWeight: '500' }}>
                Selected: {answerOptions[0].optionText}
              </div>
            )}
          </div>
        </div>
      );
    }

    // Default to text input for other types
    return (
      <div key={q.questionId} style={{
        marginBottom: '1.5rem',
        padding: '1rem',
        border: '1px solid #e0e0e0',
        borderRadius: '6px'
      }}>
        {baseLabel}

        <div style={{
          marginLeft: '16px',
          marginTop: '8px',
          padding: '8px',
          border: '1px solid #e0e0e0',
          borderRadius: '4px',
          backgroundColor: '#f9f9f9'
        }}>
          {answerText || 'No answer provided'}
        </div>
      </div>
    );
  };

  render() {
    const { showSurvey, surveyData, submitted, loading, error } = this.state;

    if (loading) return <div>Loading survey...</div>;
    if (error) return <div style={{ color: 'red' }}>Error: {error}</div>;

    return (
      <div style={{
        maxWidth: 700,
        margin: 'auto',
        backgroundColor: '#fff',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <img src={logo} width="200" alt="MAX MRJ" style={{ marginBottom: '1rem' }} />
          <h2 style={{ color: '#00A9A5', margin: '0.5rem 0' }}>{surveyData.surveyForm.title}</h2>
          <p style={{ color: '#666', margin: '0' }}>{surveyData.surveyForm.description}</p>
        </div>

        <div style={{
          backgroundColor: '#f0f8ff',
          padding: '1rem',
          borderRadius: '6px',
          marginBottom: '1.5rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div>
            <strong>Submitted on:</strong>{" "}
            {/* {surveyData?.submittedAt ? new Date(surveyData.submittedAt).toLocaleString() : "-"} */}

             {/* {surveyData?.submittedAt ? this.formatBackendDate(surveyData.submittedAt) : "-"} */}
              {surveyData?.submittedAt ? this.pacificFormatBackendDate(surveyData.submittedAt,"MM/dd/yyyy hh:mm:ss a") : "-"}

          </div>

          <div>
            <strong>Status:</strong> {surveyData.surveyStatus || "No status available"}
          </div>
          {/* <div>
              <strong>Response ID:</strong> {surveyData.formResponseId}
            </div> */}
        </div>

        {showSurvey && surveyData.surveyForm.questions.map((q, i) => this.renderQuestion(q, i))}

        {/* {submitted && (
            <div style={{ 
              marginTop: '2rem', 
              padding: '1rem',
              backgroundColor: '#f0fff0',
              borderRadius: '6px',
              textAlign: 'center',
              border: '1px solid #d6e9c6'
            }}>
               <p style={{ 
                fontWeight: '500', 
                color: '#3c763d',
                margin: '0'
              }}
                 {surveyData.surveyForm.endText || 'Thank you for your response!'} 
              </p> 
            </div>
          )} */}
      </div>
    );
  }
}

export default PreviewSubmittedSurvey;